"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _defineProperty = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.define-property");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDefaultProps = void 0;

var _propTypes = require("prop-types");

var withDefaultProps = function withDefaultProps(propTypes, defaultProps) {
  return function (ForwardRef) {
    ForwardRef.propTypes = _objectSpread({
      component: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.elementType]),
      className: _propTypes.string,
      'data-testid': _propTypes.string,
      withRef: _propTypes.object
    }, propTypes);
    ForwardRef.defaultProps = _objectSpread({
      component: 'div'
    }, defaultProps);
    return ForwardRef;
  };
};

exports.withDefaultProps = withDefaultProps;